// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d3a9d793","732":"4b5c74c1","977":"4eb94a29"}[chunkId] + ".chunk.js";
};